import { convertToImageKitUrl } from '@lemonadefashion/imagekit';

class Theme {
  constructor(themeData) {
    this.themeData = themeData;
  }

  getFooterLogo() { return convertToImageKitUrl(this.themeData.footerLogo, {}); }
  getNavbarLogo() { return convertToImageKitUrl(this.themeData.navbarLogo, {}); }
  getInvoiceLogo() { return convertToImageKitUrl(this.themeData.invoiceLogo, {}); }

  getDesktopNavbarInfo() { return this.themeData.fixedNavbar.desktop; }
  getMobileNavbarInfo() { return this.themeData.fixedNavbar.mobile; }
  getGeneralNavbarInfo() { return this.themeData.fixedNavbar.generalInfo; }

  getFeaturedTargetSlugs(target) {
    const toCamelCase = (str) => str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    const featuredTargetSlugsKey = toCamelCase(`featured_${target}_slugs`);
    return this.themeData.fixedNavbar.generalInfo[featuredTargetSlugsKey];
  }

  getSiteFooterInfo() { return this.themeData.siteFooter; }
  getPaymentLogosInfo() { return this.themeData.paymentLogos; }
}

export default Theme;
